import { BreakpointsOptions } from "@mui/material";
import createTheme from "@mui/material/styles/createTheme";

import { green, grey, white, black } from "./palette";
import { DEFAULT_CONFIG } from "@/utils/config";

const typography = {
  fontFamily: ["Inter", "sans-serif"].join(","),
};

const components = {
  MuiButton: {
    defaultProps: {
      disableElevation: true,
      disableRipple: true,
      sx: {
        textTransform: "none",
      },
    },
  },
  MuiLink: {
    defaultProps: {
      fontWeight: 500,
    },
  },
  MuiFormHelperText: {
    defaultProps: {
      sx: {
        m: 0,
        fontWeight: 400,
        color: grey[500],
      },
    },
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        backgroundColor: "black",
      },
    },
  },
};

const shape = {
  borderRadius: 8,
};

const success = {
  main: green[500],
  contrastText: white,
};
const error = {
  main: "rgba(239, 65, 70, 1)",
  contrastText: white,
};

const lightTheme = (fontFamily?: string, breakpoints?: BreakpointsOptions) =>
  createTheme({
    typography: fontFamily ? { fontFamily } : typography,
    components,
    shape,
    breakpoints: breakpoints,
    palette: {
      mode: "light",
      success,
      error,
      background: {
        paper: "#FFFFFF",
        default: "#F2F9FD",
      },
      primary: {
        ...DEFAULT_CONFIG.ui.theme.dark.primary,
        contrastText: black,
      },
      secondary: {
        main: "#34495E",
        dark: "#1D2D3D",
        light: "#B87FE7",
        contrastText: white,
      },
      divider: "#6C8BA8",
      text: {
        primary: "#1D2433",
        secondary: "#767A83",
      },
    },
  });

const darkTheme = (fontFamily?: string, breakpoints?: BreakpointsOptions) =>
  createTheme({
    typography: fontFamily ? { fontFamily } : typography,
    components,
    shape,
    breakpoints: breakpoints,
    palette: {
      mode: "dark",
      success,
      error,
      background: DEFAULT_CONFIG.ui.theme.dark.background,
      primary: { ...DEFAULT_CONFIG.ui.theme.dark.primary, contrastText: white },
      secondary: {
        main: "#6C8BA8",
        dark: "#763FB8",
        light: "#B87FE7",
        contrastText: white,
      },
      divider: "#6C8BA8", //grey[700],
      text: {
        primary: grey[200],
        secondary: grey[400],
      },
    },
  });

const makeTheme = (
  variant: "dark" | "light",
  fontFamily?: string,
  breakpoints?: BreakpointsOptions
) =>
  variant === "dark"
    ? darkTheme(fontFamily, breakpoints)
    : lightTheme(fontFamily, breakpoints);

const darkGreyButtonTheme = createTheme({
  typography,
  components,
  shape,
  palette: {
    primary: {
      main: grey[900],
    },
  },
});

const lightGreyButtonTheme = createTheme({
  typography,
  components,
  shape,
  palette: {
    primary: {
      main: grey[200],
    },
  },
});

// Maybe we should not export dark and light theme button from the package
export { makeTheme, darkGreyButtonTheme, lightGreyButtonTheme };
